import { type ReactNode, useSyncExternalStore } from 'react'
import { createPortal } from 'react-dom'

// The desktop header's title slot, published by Header through a callback ref, so a page
// re-renders when the header mounts or unmounts it (e.g. switching to MobileHeader).
let slot: HTMLElement | null = null
const listeners = new Set<() => void>()

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

const getSnapshot = () => slot

export const setPageTitleActionsSlot = (element: HTMLElement | null) => {
  if (slot === element) {
    return
  }
  slot = element
  listeners.forEach((listener) => listener())
}

interface IProps {
  children: ReactNode
}

/** Renders a page's controls beside its title in the header, or in place where there is none. */
const PageTitleActions = ({ children }: IProps) => {
  const target = useSyncExternalStore(subscribe, getSnapshot)
  return target ? createPortal(children, target) : <>{children}</>
}

export default PageTitleActions
